export enum HtmlTagNames {
  Div = 'div',
  Span = 'span',
  Input = 'input',
  Checkbox = 'checkbox',
  Label = 'label',
  Img = 'img',
  Button = 'button',
}
export enum HtmlAttrsNames {
  For = 'for',
  Tooltip = 'tooltip',
  InnerHTML = 'innerHTML',
  Src = 'src',
  Alt = 'alt',
}
export const p = text => `<p>${text}</p>`;
export const italic = text => `<i>${text}</i>`;
export const strong = text => `<strong>${text}</strong>`;
